import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'react-bootstrap/Carousel';
import './Carousel.scss';

const UserPostViewer = ({userPost}) => {

  const {
    media_url: mediaUrl,
    thumb_url: thumbUrl, 
    platform: platform,
    is_video: isVideo,
    is_carousel: isCarousel,
    carousel_media_urls: carouselMediaUrls,
    carousel_video_urls: carouselVideoUrls,
    ext_id: extId } = userPost;
  
  const media = () => {
    if (!mediaUrl) { return (''); }
    if (platform == 'youtube') { 
      // return <img className="m-auto" src={thumbUrl}/>
      return <iframe allowFullScreen="allowFullScreen" width= "100%" allowtransparency= "true"  frameBorder="0"
        src={`https://www.youtube.com/embed/${extId}?ecver=1&amp;iv_load_policy=1&amp;rel=0&amp;yt:stretch=16:9&amp;autohide=1&amp;color=red&amp;width=560&amp;width=560`}/>
    }
    if (isVideo) {
      return <video width="100%" controls><source src={mediaUrl}/></video>
    }
    if (platform == 'tiktok') { 
      return <img className="m-auto" src={thumbUrl}/>
    }
    if (platform == 'google_web_story') {
      userPost['frame_renderable'] = true;
      userPost['hide_qa_result'] = true;
      return <GoogleWebStoryViewer userPost={userPost} showDebugLink={false} />
    }
    if (isCarousel) {
      return (<Carousel >
        {carouselMediaUrls.map((mediaUrl, index) =>
          <Carousel.Item key={mediaUrl}>
            <img src={mediaUrl} key={mediaUrl} style={{maxWidth: "100%", maxHeight: "100%"}}/>
            { (carouselVideoUrls[index] && carouselVideoUrls[index].slice(-4) == '.mp4') ?
                <i className="fas fa-play carousel-video-icon"></i>
                :
                null
            }
          </Carousel.Item>
        )}
      </Carousel>);
    }
    return(<img className="m-auto" width="100%" src={mediaUrl}/>)
  }

  return  <div className='media-container alternative'>
      {media()}
  </div>
}

UserPostViewer.propTypes = {
  userPost: PropTypes.object.isRequired
};

export default UserPostViewer;